import virtualClassroomManagerRoutes from 'modules/virtualClassrooms/common/routing/managerRoutes'

const base = `${virtualClassroomManagerRoutes.events}/schedules`

const routes = {
  root: base,
  list: `${base}/list`,
  create: `${base}/create`,
  edit: `${base}/edit`,
}

export default routes
